// Flex Block - Tabs: Tab-Navigation + Swiper-Slider pro Panel
import SwiperCore, { Navigation, Pagination } from 'swiper/core';
SwiperCore.use([Navigation, Pagination]);

document.querySelectorAll('[data-tabs]').forEach(function (block) {
    var tabs = Array.prototype.slice.call(block.querySelectorAll('.tabs--tab'));
    var panels = Array.prototype.slice.call(block.querySelectorAll('.tabs--panel'));
    var sliders = [];

    // Slider pro Panel initialisieren
    panels.forEach(function (panel, i) {
        var el = panel.querySelector('.tabs--slider');
        if (!el) {
            return;
        }
        sliders[i] = new SwiperCore(el, {
            slidesPerView: 1,
            spaceBetween: 16,
            speed: 500,
            observer: true,
            observeParents: true,
            navigation: {
                nextEl: panel.querySelector('.tabs--slider--next'),
                prevEl: panel.querySelector('.tabs--slider--prev'),
            },
            pagination: {
                el: panel.querySelector('.tabs--slider--dots'),
                clickable: true,
                bulletClass: 'tabs--slider--dot',
                bulletActiveClass: 'is-active',
            },
        });
    });

    function activate(index, focus) {
        tabs.forEach(function (tab, i) {
            var active = i === index;
            tab.classList.toggle('is-active', active);
            tab.setAttribute('aria-selected', active ? 'true' : 'false');
            tab.tabIndex = active ? 0 : -1;
        });
        panels.forEach(function (panel, i) {
            panel.hidden = i !== index;
        });
        if (sliders[index]) {
            sliders[index].update();
        }
        if (focus) {
            tabs[index].focus();
        }
    }

    tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () {
            activate(i, false);
        });
        // Pfeiltasten-Navigation (WAI-ARIA Tabs)
        tab.addEventListener('keydown', function (e) {
            var next = null;
            if (e.key === 'ArrowRight') next = (i + 1) % tabs.length;
            if (e.key === 'ArrowLeft') next = (i - 1 + tabs.length) % tabs.length;
            if (e.key === 'Home') next = 0;
            if (e.key === 'End') next = tabs.length - 1;
            if (next !== null) {
                e.preventDefault();
                activate(next, true);
            }
        });
    });
});
